import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, vModelText as _vModelText, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/gongdan_ic_shoudong@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-5e3c2af0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tl" }
const _hoisted_2 = { class: "tl_title" }
const _hoisted_3 = { class: "tl_title_left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl_title_left_x" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "产出信息", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "增加产出", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "tl_list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl_list_item_label" }, "选择工装", -1))
const _hoisted_12 = { class: "tl_list_item_go" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "black"
}
const _hoisted_15 = {
  key: 2,
  class: "red"
}
const _hoisted_16 = {
  key: 3,
  class: "yellow"
}
const _hoisted_17 = {
  key: 4,
  class: "green"
}
const _hoisted_18 = {
  key: 5,
  class: "black"
}
const _hoisted_19 = { class: "tl_list_item" }
const _hoisted_20 = { class: "tl_list_item_label" }
const _hoisted_21 = { class: "tl_list_item_go" }
const _hoisted_22 = ["onBlur", "onUpdate:modelValue"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl_zw" }, null, -1))
const _hoisted_24 = { class: "tl_footer" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl_z" }, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_27 = [
  _hoisted_26
]

import { ref, onMounted, watch } from 'vue'
    import { Toast } from 'vant'
    import { useRoute, useRouter } from "vue-router"
    import {queryById, createProduce, getOrocessRecord} from '@/apis/WorkOrderAPI'
    import { REGULAR } from '@/utils/utils'
    import { Attribute } from '@/enum'
    import VWorkOrderInfo from '@/components/common/WorkOrderInfo.vue'
    import Tooling from '@/components/common/Tooling.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()

    const router = useRouter()

    let info: any = ref({})

    // 投料索引
    let indexs = ref<number>()
    let total = ref<number>(0)
    let gzShow = ref<boolean>(false)

    // 投料信息数组
    let formList: any = ref([
        {
            id: Date.now(),
            toolingTypeId: '',    // 工装类型
            toolingTypeName: '',// 工装类型名称
            workClothesId: '',    // 工装
            workClothesName: '',// 工装名称
            num: route.query.num,              // 数量
            attribute: '',         // 工装属性
            attributeType: ''         // 工装属性类型
        }
    ])

    // 复制投料
    const copy = () => {
        getOrocessRecord({
            workorderId: route.query.id,
            type: 0
        }).then(res => {
            if (res.code === 200) {
                if (res.data && res.data.length === 0) {
                    Toast({ message: '暂无投料' })
                    return
                }
                formList.value = []
                res.data.forEach((element: any) => {
                    formList.value.push({
                        id: Date.now(),
                        toolingTypeId: element.amodel.type,    // 工装类型
                        toolingTypeName: element.amodel.categoryId, // 工装类型名称
                        workClothesId: element.amodel.id,    // 工装
                        workClothesName: element.amodel.code, // 工装名称
                        num: element.num,              // 数量
                        attribute: element.smodelCode,         // 工装属性
                        attributeType: element.smodelLabel        // 工装属性类型
                    })
                })
            }
        })
    }

    const close = () => {
        gzShow.value = false
    }

    // 获取工装数据
    const getValue = (item: any) => {
        formList.value[indexs.value as number].toolingTypeId = item.cmodel1BigName
        formList.value[indexs.value as number].toolingTypeName = item.categoryId
        formList.value[indexs.value as number].workClothesId = item.id
        formList.value[indexs.value as number].workClothesName = item.code
        formList.value[indexs.value as number].attribute = item.smodelCode
        formList.value[indexs.value as number].attributeType = item.smodelLabel
        gzShow.value = false
    }

    // 失去焦点验证整数小数
    const changeNumber = (num: any, index: number): void => {
        if (info.value.umodel.attributeData === 0 && num !== '') {
            if(!REGULAR.positiveInteger.test(num)){
                Toast({ message: '只能输入正整数' })
                formList.value[index].num = ''
            }
        } else if (info.value.umodel.attributeData === 1 && num !== '') {
            if(!REGULAR.number.test(num)){
                Toast({ message: '只能输入正整数或小数（最多四位）' })
                formList.value[index].num = ''
            }
        }
    }

    // 打开工装弹框
    const open1 = (index: number): void => {
        indexs.value = index
        gzShow.value = true
    }

    // 添加投料信息
    const add = (): void => {
      formList.value.unshift({ id: Date.now(), toolingTypeId: '', toolingTypeName: '', workClothesId: '', workClothesName: '', num: formList.value[formList.value.length - 1].num })
    }

    // 删除投料信息
    const dele = (index: number): void => {
      if (formList.value.length === 1) {
        Toast('至少保留一条投料信息')
        return
      }
      formList.value.splice(index, 1)
    }

    // 查询工单详情
    const queryByIds = () => {
        queryById(route.query.id).then(res => {
            if (res.code === 200) {
                info.value = res.data
            }
        })
    }

    // 提交产出
    const submit = () => {

      let isOpen: any = true

      formList.value.forEach((item: any) => {
        if (item.toolingTypeId === '' || item.workClothesId === '' || item.num === '') {
          isOpen = false
        }
      })

      if (isOpen) {
        let recordList: any = []
        formList.value.forEach((item: any) => {
            recordList.push({ applianceId: item.workClothesId, num: item.num })
        })
        createProduce({
          id: route.query.id,
          recordList: recordList
        }).then(res => {
          if (res.code === 200) {
            Toast.success({
              message: '产出成功',
              duration: 2000,
              forbidClick: true
            })
            setTimeout(() => [
              router.go(-1)
            ], 2000)
          }
        })
      } else {
        Toast({
          message: '请先完善产出信息',
          duration: 2000
        })
      }
    }

    watch(() => formList.value, (news) => {
        total.value = 0
        news.forEach((element: any) => {
            total.value = total.value + Number(element.num)
        })
    }, { deep: true })

    onMounted(() => {
        queryByIds()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(VWorkOrderInfo, { info: _unref(info) }, null, 8, ["info"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _withDirectives(_createElementVNode("span", null, _toDisplayString(_unref(total)) + _toDisplayString(_unref(info).umodel ? _unref(info).umodel.name : ''), 513), [
            [_vShow, _unref(total) > 0]
          ])
        ]),
        _createElementVNode("div", {
          class: "tl_title_right",
          onClick: add
        }, _hoisted_8)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formList), (item, index) => {
        return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: index }, {
          right: _withCtx(() => [
            _createVNode(_component_van_button, {
              square: "",
              style: {"height":"100%"},
              type: "danger",
              text: "删除",
              onClick: ($event: any) => (dele(index))
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "tl_list_item",
                onClick: ($event: any) => (open1(index))
              }, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", {
                    style: _normalizeStyle(item.workClothesName ? 'color: #000000;' : '')
                  }, [
                    (!item.attributeType)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "点击选择工装"))
                      : (item.attributeType === _unref(Attribute).HH)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString('[' + item.attribute + ']'), 1))
                        : (item.attributeType === _unref(Attribute).BF)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString('[' + item.attribute + ']'), 1))
                          : (item.attributeType === _unref(Attribute).BL)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString('[' + item.attribute + ']'), 1))
                            : (item.attributeType === _unref(Attribute).HG)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString('[' + item.attribute + ']'), 1))
                              : _createCommentVNode("", true),
                    (item.attributeType)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(item.workClothesName), 1))
                      : _createCommentVNode("", true)
                  ], 4),
                  _createVNode(_component_van_icon, {
                    name: "arrow",
                    color: "#999999"
                  })
                ])
              ], 8, _hoisted_10),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, "产出数量(" + _toDisplayString(_unref(info).umodel ? _unref(info).umodel.name : '') + ")", 1),
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    onBlur: ($event: any) => (changeNumber(item.num, index)),
                    "onUpdate:modelValue": ($event: any) => ((item.num) = $event)
                  }, null, 40, _hoisted_22), [
                    [_vModelText, item.num]
                  ])
                ])
              ])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _hoisted_23,
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("button", {
          class: "tl_footer_copy",
          onClick: copy
        }, "复制投料"),
        _hoisted_25,
        _withDirectives((_openBlock(), _createElementBlock("button", {
          class: "tl_footer_submit",
          onClick: submit
        }, _hoisted_27)), [
          [_directive_preventReClick]
        ])
      ])
    ]),
    _createVNode(Tooling, {
      show: _unref(gzShow),
      classification: true,
      attribute: _unref(info).type === 2 ? `${_unref(Attribute).BF},${_unref(Attribute).HG}` : '',
      onClose: close,
      onValue: getValue
    }, null, 8, ["show", "attribute"])
  ], 64))
}
}

})